import * as types from './qualityCheckActionTypes.js';

export const setQualityCheckTypes = (qualityCheckTypes) => ({ type: types.SET_QUALITYCHECKTYPES, qualityCheckTypes: qualityCheckTypes });
export const setQualityChecks = (qualityChecks) => ({ type: types.SET_QUALITYCHECKS, qualityChecks: qualityChecks });
export const setQualityCheckOrders = (qualityCheckOrders) => ({ type: types.SET_QUALITYCHECKORDERS, qualityCheckOrders: qualityCheckOrders });

